import VueElementLoading from 'vue-element-loading';
import Treeselect from '@riophae/vue-treeselect';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable'
import Pagination from '../../../../shared/components/pagination'
import Tripservices from '../../../services/firstAndLastmilemanagement.service'
import CryptoJS from 'crypto-js';
import iptracker from '../../../../../views/components/commonfunction/iptracker';


export default {
    name: 'markdamagemps',
    components: {
        VueElementLoading,
        Treeselect,
        CustomExpandableTable,
        iptracker,
        Pagination
    },
    props:['parentobj'],
    data: function() {
        return{
         isLoading: false,
        //  showmarkdamagemps:false,
         mpsnumber:'',
         regionname:'',
         originname:'',
         currenthubname:'',
         markdamagehubname:'',
         description:'',
         awbnumber:'',
         originhubid:'',
         currenthubid:'',
         markdamagezonearr: [],
         markdamagezonelist:[
            // { id:1, label:'East'},
            // { id:2, label:'West'},
            // { id:3, label:'North'},
            // { id:4, label:'South-1'},
            // { id:5, label:'South-2'},
            // { id:6, label:'Central'},
            // { id:7, label:'North East'},
          ],
        mpsdisableflag:false,
        disableflag:true,
        // conditionflag:false,
        markconditionarr:[],
        damagezone:null,
        markcondition:null,
        MarkConditionList:[
            { id:38, label:'Shipment received in Inner Packaging (Open) Damage condition'},
            { id:22, label:'Shipment received in Outer Packaging Damage Condition'},
            { id:49, label:'Shipment received in leakage Condition'},
        ],
        regionid:'',
        markdamagehubid:'',
        lastoutscanhubid:'',
        lastoutscanhubname:'',
        // imagearray: ['https://stage-cargo-tms-xbees.s3.ap-south-1.amazonaws.com/DocFile/MPS88989888998/Screenshot%20from%202021-04-27%2015-09-31%20%281%29.png','https://stage-cargo-tms-xbees.s3.ap-south-1.amazonaws.com/DocFile/MPS88989888998/Screenshot%20from%202021-04-23%2011-25-09%20%282%29.png'],
        imagearray:[],
        damageimage:'',
        damagecaption:'Damage MPS Images',
        ShowDamageImages:false,
        mpsnumberErr:'',
        regionnameErr:'',
        originnameErr:'',
        currenthubnameErr:'',
        markdamagehubnameErr:'',
        descriptionErr:'',
        damagezoneErr:'',
        markconditionErr:'',
        damagedocErr:'',
        userName:'',
        HubId:'',
        userdetail:{},
        HubName:''
        }
    },
    async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    this.HubId = userdetail.hubID[0];
    this.HubName = userdetail.currentHubName
    this.userdetail = userdetail;
    if(this.parentobj && this.parentobj.mps){
        this.mpsnumber = this.parentobj.mps
        await this.searchMPS()
      }
      else{
        this.getHubDetails()
      }
    },
    methods: {
    damagempslist(){
        this.$emit("goBackToParent")
    },
      async getHubDetails(){
        try{
          this.isLoading = true
          let hubId = []
          hubId.push(this.HubId)
          let input = {
            HubID:hubId
          }
          let result = await Tripservices.GetHubDetailsForDamageMarking(input)
          for (var i = 0; i < result.data.data.length; i++) {
            this.markdamagezonelist.push({
              'id': result.data.data[i].HubZoneId,
              'label': result.data.data[i].HubZoneName
            })
          }
          this.damagezone = result.data.data[0].HubZoneId
		  console.log("Damage Zone --",this.damagezone)
          this.isLoading = false
        }catch(err){
          this.isLoading = false
          console.log(err)
        }
      },
    async UploadDocument (event){
        try{
        this.isLoading = true
        let uploadFile = event.target.files;
        this.imagearray = []
        if(this.mpsnumber==''|| this.mpsnumber==null){
            this.$alertify.error("Images could not be uploaded. Please enter MPS number");
            this.isLoading = false
        }
        else{
            let formData = new FormData();
            let size = 0
            for (let key in uploadFile) {
                if(key >= 0 ){
                  if(uploadFile[key].type != "image/jpeg" &&
                uploadFile[key].type != "image/jpg" && uploadFile[key].type != "image/png")
                {
                  this.$alertify.error("Please upload only valid file format");
                  this.isLoading = false
                  return false
                }
                }
                size = uploadFile[key].size + size
                if (size > (1024 * 1024 * 6)) {
                  this.$alert(`Uploaded file size is greater than 6000KB`, "", "error");
                  this.isLoading = false
                  return false
                } else {
                  formData.append("file", uploadFile[key]);
                }
              }
              formData.append("mps", this.mpsnumber);
              let result = await Tripservices.UploadDamageMPSImage(formData)
              if (result.data.code == 200) {
                result.data.data.map(obj => {
                  this.imagearray.push(obj.Location)
                })
                this.$alertify.success("Images uploaded successfully !");
                this.damagedocErr = ''
              }
              else{
                this.$alertify.error("Images could not be uploaded.");
                this.isLoading = false
              }
              this.isLoading = false
        }
    }
    catch(err){
        this.isLoading = false
        console.log(err)
      }
    },
    async searchMPS(){
        try{
        this.markdamagezonelist = [];
       await this.getHubDetails();
        if(this.mpsnumber==''||this.mpsnumber==null){
            let err = 0
            this.mpsnumberErr = "Please enter MPS Number"
            err = 1
        }
        else {
        this.mpsnumberErr = ''
        this.isLoading = true
        let input = {
            "mps":this.mpsnumber.trim(),
        }
        let result = await Tripservices.GetMPSDetailsForDamageMarking(input);
            if(result.data.code == 200){
                this.mpsdisableflag = true
                let mpsDetails = result.data.data.data
                if(mpsDetails.MarkDamageCondition){
                    this.markconditionarr = []
                    this.MarkConditionList.forEach((element,index)=>{
                        if(element.id==mpsDetails.MarkDamageCondition){
                            this.markconditionarr.push({
                                id:element.id,
                                label:element.label
                            })
                        }
                    })
                }
                if(mpsDetails.MarkDamageZoneId != null){
                    this.markdamagezonearr = [];
                    this.markdamagezonelist.forEach(element=>{
                        if(element.id==mpsDetails.MarkDamageZoneId){
                            this.markdamagezonearr.push({
                                id:element.id,
                                label:element.label
                            })
                        }
                    })
                }
                else{
                    this.markdamagezonearr = []
                    this.markdamagezonelist.forEach((element,index)=>{
                        if(element.id==mpsDetails.currentzoneid){
                            this.markdamagezonearr.push({
                                id:element.id,
                                label:element.label
                            })
                        }
                    })
                }
                // this.conditionflag = mpsDetails.MarkDamageCondition != null ? true: false
                this.awbnumber = mpsDetails.ParentAWB
                this.mpsnumber = mpsDetails.ShippingID
                this.regionname = mpsDetails.currentzonename
                this.regionid = mpsDetails.currentzoneid
                this.originhubid = mpsDetails.OriginHubId
                this.originname = mpsDetails.originhubname
                this.currenthubid = mpsDetails.CurrentHubId
                this.currenthubname = mpsDetails.currenthubname
                //this.damagezone = mpsDetails.MarkDamageZoneId ==null ? mpsDetails.currentzoneid : mpsDetails.MarkDamageZoneId
                this.markdamagehubname = mpsDetails.markdamagehubname == null ? this.HubName : mpsDetails.markdamagehubname
                this.markdamagehubid = mpsDetails.MarkDamageHubId == null ? this.HubId : mpsDetails.MarkDamageHubId
                this.markcondition = mpsDetails.MarkDamageCondition
                this.imagearray = mpsDetails.images == null? []:mpsDetails.images
                this.description = mpsDetails.Description
                this.lastoutscanhubid = mpsDetails.shipmentoutscanhubid
             this.lastoutscanhubname = mpsDetails.shipmentoutscanhubname
                this.isLoading = false
                if(this.validator())return;
            }
        else {
                this.$alertify.error(result.data.message)
                this.isLoading = false;
            }
        }
        }catch(err){
            this.isLoading = false;
        console.log(err);
        }
    },
    selectMarkCondition(data){
        this.markconditionarr = []
            this.markconditionarr.push({
                id:data.id,
                label:data.label
            })
        this.markconditionErr = ''
    },
    selectMarkDamageZone(data){
        this.markdamagezonearr = []
        this.markdamagezonearr.push({
            id:data.id,
            label:data.label
        })
    },
    decriptionfunction(data){
        if(data.length > 0){
            this.descriptionErr = ''
        }else{
            this.descriptionErr = "Please enter description"
        }   
    },
    reset(){
        // this.conditionflag = false
        this.mpsdisableflag = false
        this.description = ''
        this.markcondition = null
        this.markdamagehubname = ''
        this.damagezone = null
        this.currenthubid = ''
        this.originhubid = ''
        this.currenthubname = ''
        this.originname = ''
        this.regionname = ''
        this.mpsnumber = ''
        this.mpsnumberErr = ''
        this.regionnameErr = ''
        this.originnameErr = ''
        this.currenthubnameErr = ''
        this.markdamagehubnameErr = ''
        this.descriptionErr = ''
        this.damagezoneErr = ''
        this.markconditionErr = ''
        this.damagedocErr = ''
        this.imagearray = []
        this.regionid = ''
        this.markdamagehubid =''
        this.lastoutscanhubid = '',
        this.lastoutscanhubname = ''
        this.markdamagezonelist = []
        this.getHubDetails()
    },
    async save(){
        try{
        if(this.validator())return;
        else if(this.currenthubid != this.HubId){
            this.$alertify.error("Unable to Mark Damage: MPS does not belong to the Current Hub")
        }
        else {
            this.isLoading = true
            let input = {
                "awb":this.awbnumber,
                "mps":this.mpsnumber,
                "currentregionname":this.regionname,
                "currentregionid":this.regionid,
                "originhubid":this.originhubid,
                "originhubname":this.originname,
                "currenthubid":this.currenthubid,
                "currenthubname":this.currenthubname,
                "markdamagezone":this.markdamagezonearr[0].id,
                "markdamagezonename": this.markdamagezonearr[0].label,
                "markdamagehubid":this.HubId,
                "markdamagehubname":this.HubName,
                "damagereasonid":this.markconditionarr[0].id,
                "damagereason":this.markconditionarr[0].label,
                "damageimages":this.imagearray,
                "description":this.description,
                "lastoutscanhubid":this.lastoutscanhubid,
                "lastoutscanhubname":this.lastoutscanhubname,
                "lastmodifiedby":this.userName
            }
            let result = await Tripservices.MarkMPSDamage(input)
            this.isLoading = false
            if(result.data.code==200){
                this.$alertify.success(result.data.message)
                this.getTraceIP(input)
            }
            else if(result.data.code== 409){
                    this.$alertify.error(result.data.data.error)
            }
            else {
                this.$alertify.error(result.data.message)
            }
        }
    }
    catch(err){
        this.isLoading = false
        console.log(err)
      }
    },
    validator(){
        let err = 0
        if(this.mpsnumber==''||this.mpsnumber==null){
            this.mpsnumberErr = "Please enter mps number"
            err = 1
        }
        else{
            this.mpsnumberErr = ''
        }
        if(this.regionname==''||this.regionname==null){
            this.regionnameErr = "Please enter region name"
            err = 1
        }
        else{
            this.regionnameErr = ''
        }
        if(this.originname==''||this.originname==null){
            this.originnameErr = "Please enter origin hub name"
            err = 1
        }
        else{
            this.originnameErr = ''
        }
        if(this.currenthubname==''||this.currenthubname==null){
            this.currenthubnameErr = "Please enter current hub name"
            err = 1
        }
        else{
            this.currenthubnameErr = ''
        }
        if(this.description==''||this.description==null){
            this.descriptionErr = "Please enter description"
            err = 1
        }
        else{
            this.descriptionErr = ''
        }
        if(this.damagezone==''||this.damagezone==null){
            this.damagezoneErr = "Please select damagezone"
            err = 1
        }
        else{
            this.damagezoneErr = ''
        }
        if(this.markcondition==''||this.markcondition==null){
            this.markconditionErr = "Please select mark condition"
            err = 1
        }
        else{
            this.markconditionErr = ''
        }
        if(this.imagearray.length <= 0){
            this.damagedocErr = "Please upload images"
            err = 1
        }
        else{
            this.damagedocErr = ''
        }
        return err
    },
    openImage(image) {
        this.damageimage = image;
        this.$nextTick(() => {
        let modal = document.getElementById('myModalImg' + image);
        var img = document.getElementById('imgid' + image);
        var modalImg = document.getElementById("img" + image);
        var captionText = document.getElementById("captionImg" + this.damagecaption);
        modal.style.display = "block";
        modalImg.src = image;
        captionText.innerHTML = this.damagecaption;
        this.ShowDamageImages =false;
        })
      },
      getTraceIP(data) {
        try {
          let payload = 
          {
            "projectname": this.userdetail.project,
            "type": "web",
            "userid": this.userdetail.userid,
            "username": this.userdetail.username,
            "routeurl":'/damagempslisting',
            "meta" : {
              "event" : `Cargo Shipment Damage Mark`,
              "data" : data
            }
        }
        let result = iptracker.getTraceIP(payload);
        } catch (error) {
          console.log(error)
        }
      },
    closemodal(id) {
        let modal = document.getElementById(id);
        modal.style.display = "none";
        this.ShowDamageImages =true;
    },
    selectRemove(data,index){
        this.imagearray.splice(index,1)
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/DamageMPS/markdamageMPS/markdamageMPS.component.js